import GoogleMapsLoader from 'google-maps'
import { Html4Entities as HtmlEntities } from 'html-entities'

require('js-marker-clusterer');

GoogleMapsLoader.KEY = 'AIzaSyB7fB9JDDBe2ke1-UuWmKquL2eWbFT_8bY'
// GoogleMapsLoader.KEY = 'AIzaSyAFvQGHnSae5bB0sIKr67DVd0cZK0SbtT8'


export default {
	template: `
		<div class="stockists">
			<header class="stockists__header entry__header">
				<h1 class="stockists__title entry__header__title">Stockists</h1>
				<nav class="stockists__nav">
					<ul class="stockists__nav-flat">
						<li class="stockists__nav-flat-li"
							v-for="regionParent in regionParents">
							<a class="stockists__nav-flat-a"
								:href="'#' + regionParent.regions[0].slug"
								:class="{ 'stockists__nav-flat-a--active': hasActiveChildRegion(regionParent) }">
								{{ regionParent.title }}
							</a>
							<ul class="stockists__nav-dropdown">
								<li class="stockists__nav-dropdown-li"
									v-for="region in regionParent.regions">
									<a class="stockists__nav-a"
										:href="'#' + region.slug"
										:class="{ 'stockists__nav-a--active': activeMap === region.slug }">
										{{ region.title }}
									</a>
								</li>
							</ul>
						</li>
					</ul>
				</nav>
			</header>
			<div class="entry__content stockists__content">
				<div class="stockists__finder">
					<fieldset class="stockists__finder-categories">
						<legend class="stockists__finder-legend">Show me where to...</legend>
						<div v-for="category in categories"
							:class="'stockists__finder-category stockists__finder-category--' + category.slug">
							<input type="checkbox"
								@change="toggleCategory(category.slug)"
								:id="category.slug + '-lightswitch'"
								:value="1"
								:checked="isCategoryActive(category.slug)"
								:class="['stockists__finder-checkbox', { 'stockists__finder-checkbox--active': isCategoryActive(category.slug) }]">
							<label class="stockists__finder-label"
								:for="category.slug + '-lightswitch'">
								<img class="stockists__finder-icon"
									:src="'/img/marker-' + (category.slug === 'buy-it' ? 'red' : 'green') + '.png'">
								<span class="stockists__finder-text">{{ category.title }}</span>
							</label>
						</div>
					</fieldset>
					<ul class="stockists__finder-ul" ref="stockists-scrollbox">
						<li class="stockists__finder-li"
							:id="stockist.slug"
							v-for="stockist in stockists"
							v-if="isStockistActive(stockist)"
							:class="{ 'stockists__finder-li--focused': focusedStockist === stockist.slug }">
							<div class="stockists__finder-item"
								@click="focusStockist(stockist.slug)">
								<div class="stockists__finder-title">{{ decode(stockist.title) }}</div>
								<div class="stockists__finder-address"
									v-if="stockist.location.address"
									v-html="stockist.location.address"
									:id="stockist.slug">
								</div>
								<div class="stockists__finder-phone"
									v-if="stockist.phoneNumber">
									PH: <a :href="'tel:' + stockist.phoneNumber">{{ stockist.phoneNumber }}</a>
								</div>
								<div class="stockists__finder-website"
									v-if="stockist.websiteUrl">
									<a :href="stockist.websiteUrl"
										target="_blank">Website</a>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<div class="stockists__map-wrapper">
					<region-map v-for="region in regions"
						:key="'map-' + region.slug"
						:id="'map-' + region.slug"
						:maps-service="mapsService"
						:location="region.location"
						:stockists="getStockistsForRegion(region.slug)"
						:active-categories="activeCategories"
						:is-active="region.slug === activeMap"
						:focused-stockist="focusedStockist"
						@markerClick="focusStockist"
					></region-map>
				</div>
			</div>
		</div>
	`,

	props: {
		data: {
			type: Object,
			required: true
		},
		mouseoverEvent: {
			required: true
		}
	},

	data: () => ({
		regions: [],
		regionParents: [],
		stockists: [],
		categories: null,
		entry: null,
		mapsService: null,
		activeHash: '',
		focusedStockist: '',
		userLocationData: null,
		decoder: new HtmlEntities
	}),

	methods: {
		setActiveHash() {
			let userRegion = null
			if (this.userLocationData && !this.activeHash) {
				userRegion = this.regions.find(({ title }) => (title === this.userLocationData.city) || (title === this.userLocationData.region))
			}
			if (!this.activeHash) {
				window.location.hash = userRegion ? userRegion.slug : this.regions[0].slug
			}
			this.activeHash = window.location.hash.replace('#', '')
		},

		getStockistsForRegion(slug) {
			return this.stockists.filter(stockist => stockist.region === slug)
		},

		toggleCategory(slug) {
			this.categories[slug].isActive = !this.categories[slug].isActive
		},

		getCategory(slug) {
			return slug in this.categories ? this.categories[slug] : null
		},

		isCategoryActive(slug) {
			const category = this.getCategory(slug)

			return category ? category.isActive : false
		},

		focusStockist(slug) {
			this.focusedStockist = slug
			this.$refs['stockists-scrollbox'].scrollTop = document.getElementById(slug).offsetTop - 5
		},

		isStockistActive(stockist) {
			const regionActive = this.activeMap === stockist.region
			const isCategoryActive = ({ slug }) => this.isCategoryActive(slug)
			const someCategoriesActive = !!stockist.categories.find(isCategoryActive)

			return regionActive && someCategoriesActive
		},

		hasActiveChildRegion(regionParent) {
			const activeRegion = region => this.activeMap === region.slug

			return !!regionParent.regions.find(activeRegion)
		},

		decode(string) {
			return this.decoder.decode(string)
		},

		setUserLocationData() {
			let request = new XMLHttpRequest()
			request.open('GET', '//ipapi.co/json/', true)

			request.onload = () => {
				if (request.status >= 200 && request.status < 400) {
					// Success!
					this.userLocationData = JSON.parse(request.responseText);
				}
				this.setActiveHash()
			}
			request.send()
		}
	},

	computed: {
		activeMap() {
			const slugInRegions = slug => !!this.regions.find(region => region.slug === slug)
			const hashInRegions = this.activeHash && this.regions && slugInRegions(this.activeHash)
			const entryInRegions = this.entry && slugInRegions(this.regions)

			// Determine active map from URL hash, otherwise try use active entry slug
			return hashInRegions ? this.activeHash : entryInRegions ? this.entry.slug : null
		},

		activeCategories() {
			const getIsActive = obj => obj.isActive
			const getSlug = obj => obj.slug

			return Object.values(this.categories)
				.filter(getIsActive)
				.map(getSlug)
		}
	},

	watch: {
		mouseoverEvent({ target }) {
			const stockist = target && target.classList && target.classList.contains('stockists__finder-address') ? target.id : ''
			if (stockist) {
				this.focusedStockist = stockist
			}
		}
	},

	mounted() {
		const component = this
		this.userLocationData = this.setUserLocationData()
		this.regions = this.data.regions
		this.regionParents = this.data.regionParents
		this.stockists = this.data.stockists
		this.categories = this.data.categories
		this.entry = this.data.entry
		window.addEventListener('hashchange', component.setActiveHash)
		GoogleMapsLoader.load(google => component.mapsService = google.maps)
	},

	components: {
		'region-map': {
			template: `
				<div :id="id"
					:class="classes">
				</div>
			`,

			props: {
				id: {
					type: String,
					required: true
				},
				isActive: {
					type: Boolean,
					required: true
				},
				mapsService: {
					required: true
				},
				location: {
					type: Object,
					required: true
				},
				stockists: {
					type: Array
				},
				activeCategories: {
					type: Array,
					required: true
				},
				focusedStockist: ''
			},

			data: () => ({
				map: null,
				markers: [],
				options: {
					zoom: 9
				}
			}),

			computed: {
				classes() {
					return [
						'stockists__map',
						{ 'stockists__map--active': this.isActive }
					]
				}
			},

			methods: {
				updateMarkers() {
					const currentlyActiveMarkers = this.markers.filter(marker => marker.map)
					const isCategoryActive = cat => this.activeCategories.includes(cat)
					const markersToActivate = this.markers.filter(marker => !!marker.categories.filter(isCategoryActive).length && !currentlyActiveMarkers.includes(marker))
					const markersToDeactivate = this.markers.filter(marker => !marker.categories.filter(isCategoryActive).length && !markersToActivate.includes(marker))
					markersToDeactivate.forEach(marker => marker.setMap(null))
					markersToActivate.forEach(marker => marker.setMap(this.map))
					this.bounceMarkers(markersToActivate)
				},

				bounceMarkers(markers) {
					// Start bounce animation
					markers.forEach(marker => marker.setAnimation(this.mapsService.Animation.BOUNCE))
					// Stop animation after one bounce
					window.setTimeout(() => markers.forEach(marker => marker.setAnimation(null)), 700)
				},

				clickHandler(marker) {
					this.$emit('markerClick', marker.slug)
				}
			},

			watch: {
				// Run after Google maps service loads in parent
				mapsService(mapsService) {
					this.options.center = new mapsService.LatLng(this.location.lat, this.location.lng)
					// Create map
					const map = new mapsService.Map(this.$el, this.options)
					this.map = map
					// Create icons
					const iconSize = new mapsService.Size(40, 48)
					const iconAnchor = new mapsService.Point(0, 0)
					const iconify = category => ({
						url: `/img/marker-${category === 'buy-it' ? 'red' : 'green'}.png`,
						scaledSize: iconSize,
						origin: iconAnchor,
						anchor: iconAnchor
					})
					const getSlug = (obj) => obj.slug
					// Create markers
					const markerify = (stockist) => new mapsService.Marker({
						position: new mapsService.LatLng(stockist.location.lat, stockist.location.lng),
						title: stockist.title,
						slug: stockist.slug,
						categories: stockist.categories.map(getSlug),
						animation: mapsService.Animation.DROP,
						icon: iconify(stockist.categories[0].slug),
						map
					})
					// Apply markers to map
					this.markers = this.stockists.map(markerify)
					// Listen for clicks on each marker
					this.markers.forEach(marker => mapsService.event.addListener(marker, 'click', () => this.clickHandler(marker)))

					var markerCluster = new MarkerClusterer(map, this.markers,
						{imagePath: '/img/cluster_images/m'});

				},

				// After an active categories change
				activeCategories() {
					this.updateMarkers()
				},

				// After hovering over a stockist, bounce its marker
				focusedStockist(slug) {
					const marker = this.markers.find(marker => marker.slug === slug)
					if (marker) {
						this.bounceMarkers([ marker ])
					}
				}
			}
		}
	}
}
